import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { naCardBg, naCardBgHover } from "./darkSectionTokens";

function Editions() {
  let pageHeader = React.createRef();
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <div
      style={{
        backgroundColor: "transparent",
        padding: 0,
      }}
      className="section"
      data-parallax={true}
      ref={pageHeader}
    >
      <Container style={{ padding: 0 }}>
        <Row style={{ margin: 0 }}>
          <Col lg={12} className="mb-5" style={{ padding: size ? "3rem 15px 2rem" : "2rem 15px 1.5rem" }}>
            <h1
              className="text-center text-g mb-3"
              style={{
                fontSize: size ? "3.5rem" : "2rem",
                fontWeight: "700",
                letterSpacing: "0.5px",
                background: "linear-gradient(135deg, #C66067 0%, #70AEB8 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              GLOBAL EDITIONS
            </h1>
            <div
              style={{
                width: "100px",
                height: "4px",
                background: "linear-gradient(90deg, #C66067, #70AEB8)",
                borderRadius: "2px",
                margin: "0 auto",
              }}
            />
          </Col>
        </Row>
        <Row className="justify-content-center" style={{ margin: 0, padding: size ? "0 15px 3rem" : "0 15px 2rem" }}>
          {events.map((e, index) => (
            <Col lg={6} md={6} xs={12} className="mb-4" key={index} style={{ padding: "0 10px" }}>
              <a
                href={e.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  display: "block",
                  height: "100%",
                }}
              >
                <Card
                  className="edition-card"
                  style={{
                    background: naCardBg,
                    backdropFilter: "blur(20px)",
                    border: "1px solid rgba(198, 96, 103, 0.35)",
                    borderRadius: "20px",
                    padding: 0,
                    height: "100%",
                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                    cursor: "pointer",
                    overflow: "hidden",
                    position: "relative",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = naCardBgHover;
                    e.currentTarget.style.borderColor = "rgba(198, 96, 103, 0.5)";
                    e.currentTarget.style.transform = "translateY(-10px) scale(1.02)";
                    e.currentTarget.style.boxShadow = "0 20px 60px rgba(198, 96, 103, 0.4)";
                    const img = e.currentTarget.querySelector("img");
                    if (img) {
                      img.style.transform = "scale(1.05)";
                    }
                    const overlay = e.currentTarget.querySelector(".edition-overlay");
                    if (overlay) {
                      overlay.style.opacity = "0.3";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = naCardBg;
                    e.currentTarget.style.borderColor = "rgba(198, 96, 103, 0.2)";
                    e.currentTarget.style.transform = "translateY(0) scale(1)";
                    e.currentTarget.style.boxShadow = "none";
                    const img = e.currentTarget.querySelector("img");
                    if (img) {
                      img.style.transform = "scale(1)";
                    }
                    const overlay = e.currentTarget.querySelector(".edition-overlay");
                    if (overlay) {
                      overlay.style.opacity = "0";
                    }
                  }}
                >
                  {/* Image Container */}
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      overflow: "hidden",
                      borderRadius: "20px 20px 0 0",
                    }}
                  >
                    <img
                      src={e.logo}
                      alt={e.location}
                      style={{
                        width: "100%",
                        height: size ? "280px" : "200px",
                        objectFit: "cover",
                        transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        display: "block",
                      }}
                    />
                    {/* Gradient Overlay */}
                    <div
                      className="edition-overlay"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "linear-gradient(135deg, rgba(198, 96, 103, 0.4) 0%, rgba(112, 174, 184, 0.3) 100%)",
                        opacity: 0,
                        transition: "opacity 0.4s ease",
                        pointerEvents: "none",
                      }}
                    />
                  </div>

                  {/* Content */}
                  <div
                    style={{
                      padding: size ? "1rem" : "1rem",
                      textAlign: "center",
                    }}
                  >
                    <h3
                      className="text-white mb-0"
                      style={{
                        fontSize: size ? "1.25rem" : "1.1rem",
                        fontWeight: "600",
                        lineHeight: "1.5",
                        letterSpacing: "0.3px",
                        color: "#fff",
                      }}
                    >
                      {e.location}
                      {e.date && (
                        <>
                          <br />
                          <span
                            style={{
                              fontSize: size ? "1rem" : "0.9rem",
                              fontWeight: "400",
                              color: "#70AEB8",
                            }}
                          >
                            {e.date}
                          </span>
                        </>
                      )}
                    </h3>
                  </div>

                  {/* Decorative corner accent */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      width: "50px",
                      height: "50px",
                      background: "linear-gradient(135deg, rgba(198, 96, 103, 0.1) 0%, transparent 100%)",
                      borderRadius: "0 20px 0 100%",
                      pointerEvents: "none",
                    }}
                  />
                </Card>
              </a>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Editions;

const events = [
  {
    logo: require("assets/editions/dubai.jpg"),
    location: "Dubai, UAE",
    date: "",
    link: "https://me.digitaltwin-summit.com",
  },
  {
    logo: require("assets/editions/dubai.jpg"),
    location: "Egypt",
    date: "",
    link: "https://eg.digitaltwin-summit.com",
  },
  {
    logo: require("assets/editions/nz.jpg"),
    location: "Australia",
    date: "",
    link: "https://anz.digitaltwin-summit.com",
  },
  {
    logo: require("assets/editions/uk.jpg"),
    location: "North America",
    date: "Chicago, USA — Aug 2026",
    link: "https://usa.digitaltwin-summit.com",
  },
  {
    logo: require("assets/editions/saudi.jpg"),
    location: "Kingdom of Saudi Arabia",
    date: "",
    link: "https://ksa.digitaltwin-summit.com",
  },
  {
    logo: require("assets/editions/uk.jpg"),
    location: "United Kingdom",
    date: "",
    link: "https://uk.digitaltwin-summit.com",
  },
];
